import { Location, Money, Tags, Team } from '@clearkit/icons';
import classnames from 'classnames';
import { useMemo } from 'react';

import { Search } from '../hooks/useTargetMarket';
import {
  BUSINESS_MODELS,
  COMPANY_TYPES,
  COUNTRIES,
  EMPLOYEE_RANGES,
  INDUSTRIES,
  RAISED_RANGES,
  TECH,
} from './attributeOptions';
import { FilterMultiPicker } from './FilterMultiPicker';

export const TargetMarketForm = ({
  search,
  setSearch,
}: {
  search: Search;
  setSearch: any;
}) => {
  const { businessModel, companyType } = useMemo(() => {
    const businessModel: string[] = [];
    const companyType: string[] = [];

    search?.tag?.forEach((tag) => {
      if (BUSINESS_MODELS.find((model) => model.value === tag)) {
        businessModel.push(tag);
      } else if (COMPANY_TYPES.find((type) => type.value === tag)) {
        companyType.push(tag);
      }
    });

    return { businessModel, companyType };
  }, [search]);

  const updateSearch = (
    fieldName: keyof Search | 'businessModel' | 'companyType',
  ) => (value: string[]) => {
    let searchArg = fieldName;

    if (fieldName === 'businessModel') {
      searchArg = 'tag';
      value = [...companyType, ...value];
    }

    if (fieldName === 'companyType') {
      searchArg = 'tag';
      value = [...businessModel, ...value];
    }

    const newSearch = {
      ...search,
      [searchArg]: value,
    };

    setSearch(newSearch);
  };

  return (
    <div className="px-6 pb-6 space-y-8">
      <div className={classnames('divide-y space-y-4 divide-gray-200')}>
        <FilterMultiPicker
          className="pt-4"
          items={EMPLOYEE_RANGES}
          onChange={updateSearch('employees')}
          value={search?.employees ?? []}
        >
          <FilterMultiPicker.Icon>
            <Team />
          </FilterMultiPicker.Icon>
          <FilterMultiPicker.Title>Employee Range</FilterMultiPicker.Title>
        </FilterMultiPicker>

        <FilterMultiPicker
          className="pt-4"
          items={INDUSTRIES}
          onChange={updateSearch('industry')}
          value={search?.industry ?? []}
        >
          <FilterMultiPicker.Icon>
            <Tags />
          </FilterMultiPicker.Icon>
          <FilterMultiPicker.Title>Industries</FilterMultiPicker.Title>
        </FilterMultiPicker>

        <FilterMultiPicker
          className="pt-4"
          items={COUNTRIES}
          onChange={updateSearch('country')}
          value={search?.country ?? []}
        >
          <FilterMultiPicker.Icon>
            <Location />
          </FilterMultiPicker.Icon>
          <FilterMultiPicker.Title>Countries</FilterMultiPicker.Title>
        </FilterMultiPicker>

        <FilterMultiPicker
          className="pt-4"
          items={BUSINESS_MODELS}
          onChange={updateSearch('businessModel')}
          value={businessModel}
        >
          <FilterMultiPicker.Icon>
            <Tags />
          </FilterMultiPicker.Icon>
          <FilterMultiPicker.Title>Business Model</FilterMultiPicker.Title>
        </FilterMultiPicker>

        <FilterMultiPicker
          className="pt-4"
          items={COMPANY_TYPES}
          onChange={updateSearch('companyType')}
          value={companyType ?? []}
        >
          <FilterMultiPicker.Icon>
            <Tags />
          </FilterMultiPicker.Icon>
          <FilterMultiPicker.Title>Company Types</FilterMultiPicker.Title>
        </FilterMultiPicker>

        <FilterMultiPicker
          className="pt-4"
          onChange={updateSearch('description')}
          value={search?.description ?? []}
        >
          <FilterMultiPicker.Icon>
            <Tags />
          </FilterMultiPicker.Icon>
          <FilterMultiPicker.Title>Tags</FilterMultiPicker.Title>
        </FilterMultiPicker>

        <FilterMultiPicker
          className="pt-4"
          items={TECH}
          onChange={updateSearch('tech')}
          value={search?.tech ?? []}
        >
          <FilterMultiPicker.Icon>
            <Tags />
          </FilterMultiPicker.Icon>
          <FilterMultiPicker.Title>Tech Tags</FilterMultiPicker.Title>
        </FilterMultiPicker>

        <FilterMultiPicker
          className="pt-4"
          items={RAISED_RANGES}
          onChange={updateSearch('raised')}
          value={search?.raised ?? []}
        >
          <FilterMultiPicker.Icon>
            <Money />
          </FilterMultiPicker.Icon>
          <FilterMultiPicker.Title>Funding Raised</FilterMultiPicker.Title>
        </FilterMultiPicker>
      </div>
    </div>
  );
};
